import PropTypes from 'prop-types';
import React from 'react';

const Input = (props) => {
  const {
    hideLabel,
    label,
    width,
    className,
    info,
    value,
    inputRef,
    suffix,
    error,
    consoleFont,
    fullWidth,
    classNameInputField = '',
    ...rest
  } = props;
  return (
    <div
      className={`input-outer-container ${className ? className : ''}`}
      style={{ width: props.fullWidth ? '77%' : '' }}
    >
      {!hideLabel && (
        <label className={`input-label ${props.reportStyle ? '' : ' label-text'}`}>
          <span className="span-text">{label}</span>
          <span style={{ flexGrow: 1 }}></span>
          <span className="input-error-box">{error ? error : '\u00A0'}</span>
          &nbsp;
          <span>{typeof info === 'function' ? info() : (info ?? '')}</span>
        </label>
      )}
      <div
        className="input-inner-container"
        style={{
          border: props.error ? '1px red solid' : '',

          color: props.consoleFont ? '#3938ac' : '',
          fontSize: props.consoleFont ? '1.1rem' : '',
        }}
      >
        <input
          ref={inputRef}
          value={value}
          type={props.numeric ? 'number' : null}
          className={`input-element ${classNameInputField}`}
          {...rest}
          style={{
            borderTopRightRadius: suffix ? '0px' : undefined,
            borderBottomRightRadius: suffix ? '0px' : undefined,
          }}
        />
        {typeof suffix === 'function' ? suffix() : (suffix ?? '')}
      </div>
    </div>
  );
};
Input.propTypes = {
  hideLabel: PropTypes.string,
  label: PropTypes.string,
  width: PropTypes.string,
  className: PropTypes.string,
  info: PropTypes.string,
  value: PropTypes.string,
  inputRef: PropTypes.string,
  suffix: PropTypes.string,
  error: PropTypes.string,
  consoleFont: PropTypes.string,
  fullWidth: PropTypes.string,
  classNameInputField: PropTypes.string,
  reportStyle: PropTypes.string,
  numeric: PropTypes.number,
};

export default Input;
